import React, { useState, useEffect } from "react";
import { Paper } from "@material-ui/core";
import Signbutton from "../../forms/button";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { connect } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import { getDepositarySlip, getNewPurchaseFundList } from "../../../store/actions";
import { formatDate } from "../../../utils/common";
import IntegrationReactSelect from "../../forms/autoCompleteInput";
import CustomLoader from "../../forms/Loader";

const DepositarySlip = ({ token, getNewPurchaseFundList, getDepositarySlip }) => {
  const [date, setDate] = useState("");
  const [amcList, setAmcList] = useState([]);
  const [fund, setFund] = useState({ value: "" });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchAmcList = async () => {
      setIsLoading(true);
      try {
        const { Dtinformation } = await getNewPurchaseFundList({ opt: "A" });
        setAmcList(Dtinformation.map(({ amc_code, amc_name }) => ({ value: amc_code, label: amc_name })));
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchAmcList();
  }, [getNewPurchaseFundList]);

  const handleSubmit = async () => {
    try {
      const response = await getDepositarySlip({
        Branch: "DA01",
        Trdate: formatTrDate(date),
        Fund: fund.value,
        ARNCode:token,
        InvDistFlag:"G"
      });
  
      if (response?.Dtinformation[0]?.Path) {
        window.open(response.Dtinformation[0].Path);
      } else {
        alert("Error occurred while processing the request.");
      }
    } catch (error) {
      console.error("Error fetching depositary slip:", error);
      alert("An error occurred. Please try again.");
    }
  };
  
  return (
    <div className="container-margin">
    <CustomLoader display={isLoading} />
    <div className="investor-title">Deposit Slip</div>
    <Paper
      className="digital-form-container"
      style={{
        boxShadow: "0px 0px 2px 0px lightgray",
        width: "100%",
        padding: "50px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateRows: "1fr 1fr",
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <div className="input-name input-integrated-label">AMC</div>
          <IntegrationReactSelect
            suggestions={Array.isArray(amcList) && amcList}
            value={fund}
            placeholder={"Select AMC"}
            handleChange={setFund}
          />
          <div className="input-name" style={{marginTop:30}}>Transaction Date</div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                required={true}
                className="selects"
                onChange={(e) => setDate(e ? e.toLocaleDateString("en-US") : "")}
                format="dd/MM/yyyy"
                helperText={""}
                id="mui-pickers-date"
                value={date}
                disableFuture
              />
            </MuiPickersUtilsProvider>
        </div>
        <Signbutton buttontitle="View" onClick={handleSubmit} />
        </div>
    </Paper>
  </div>
);
};

export default connect(
  ({ authReducer: { token } }) => ({ token }),
  { getDepositarySlip, getNewPurchaseFundList }
)(DepositarySlip);
 function formatTrDate(dobb) {
  var dateParts = dobb.split("/");
  return dateParts[0] + "-" + dateParts[1] + "-" + dateParts[2];
}
